import { createAction } from '@reduxjs/toolkit';

export const updateUserParlay = createAction('betslip/parlayTab/updateUserParlay');
